import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/outline';
import React, { useState } from 'react';

interface IPanelProps {
  title: string;
  children: React.ReactNode;
  containerClasses?: string;
  headerClasses?: string;
}

const Panel: React.FC<IPanelProps> = ({
  children,
  title,
  containerClasses,
  headerClasses,
}) => {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <div className={`border rounded-lg mb-3 ${containerClasses}`}>
      <button
        className={`w-full flex items-center justify-between p-3 bg-gray-50 ${
          headerClasses || ''
        }`}
        onClick={setCollapsed.bind(null, !collapsed)}
      >
        <div className="flex items-center gap-2">
          {collapsed ? (
            <ChevronUpIcon className="w-4 h-4 text-gray-400" />
          ) : (
            <ChevronDownIcon className="w-4 h-4 text-gray-400" />
          )}
          <span className="font-medium">{title}</span>
        </div>
      </button>

      {!collapsed && children}
    </div>
  );
};

export default Panel;
